export const ServiceOptionActionTypes = {
    API_RESPONSE_SUCCESS: '@@serviceOption/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@serviceOption/API_RESPONSE_ERROR',
    GET_SERVICE_OPTION: '@@serviceOption/GET_SERVICE_OPTION',
    RESET_SERVICE_OPTION: '@@serviceOption/RESET_SERVICE_OPTION',
};